import React, { useState } from 'react';
import { Layout } from 'antd';
import DashboardHeader from './DashboardHeader';
import DashboardSidebar from './DashboardSidebar';
import DashboardFooter from './DashboardFooter';
import { Outlet } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { UserOutlined, SettingOutlined, LogoutOutlined } from '@ant-design/icons';

const { Content } = Layout;

const DashboardLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const userMenuItems = [
    {
      key: 'profile',
      label: <Link to="/dashboard/profile">Profile</Link>,
      icon: <UserOutlined />
    },
    {
      key: 'settings',
      label: <Link to="/dashboard/configurations">Settings</Link>,
      icon: <SettingOutlined />
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutOutlined />
    }
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <DashboardSidebar collapsed={collapsed} onItemClick={toggleSidebar} />
      <Layout>
        <DashboardHeader 
          collapsed={collapsed} 
          onToggle={toggleSidebar}
        />
        <Content style={{ 
          margin: '4px',
          padding: '8px',
          minHeight: 280,
          background: '#fff',
          borderRadius: '8px',
          overflow: 'initial'
        }}>
          <Outlet />
        </Content>
        <DashboardFooter />
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;